import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
} from '@angular/core';
import { CostComponent } from '../../components/cost/cost.component';
import { SvgIconComponent } from 'angular-svg-icon';
import { Engine, ISourceOptions } from '@tsparticles/engine';
import { NgParticlesService, NgxParticlesModule } from '@tsparticles/angular';
import { loadSlim } from '@tsparticles/slim';
import { SessionService } from '@core/services/session.service';
import { Skin } from '@core/interfaces/skin.interface';
import { BalanceType } from '@core/types/balance.type';
import { ModalService } from '@core/modals/services/modal.service';

interface TradeOptions {
  trade_offer_id: string;
  trade_hash: string;
  trade_skins: Skin[];
  typography_trade_for: string;
}

@Component({
  selector: 'app-trade-modal',
  imports: [CostComponent, SvgIconComponent, NgxParticlesModule],
  templateUrl: './trade-modal.component.html',
  styleUrl: './trade-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  host: {
    class: 'modal-container flex flex-col',
  },
})
export class TradeModalComponent {
  private readonly modalService = inject(ModalService);

  tradeModalOptions = input.required<TradeOptions>();
  balance = input<BalanceType>();

  tradeSkinsCost = computed(() => {
    return this.tradeModalOptions().trade_skins.reduce((acc, skin) => {
      return acc + skin.price;
    }, 0);
  });

  particlesOptions: ISourceOptions = {
    fullScreen: { enable: false },
    particles: {
      number: {
        value: 20,
      },
      color: {
        value: ['#ffffff'],
      },
      move: {
        direction: 'none',
        enable: true,
        outModes: {
          default: 'out',
        },
        random: true,
        speed: 1.5,
        straight: false,
      },
      opacity: {
        value: { min: 0.17, max: 0.5 },
      },
      size: {
        value: { min: 1, max: 1.2 },
      },
      wobble: {
        enable: false,
      },
    },
  };

  constructor(
    private ngParticlesService: NgParticlesService,
    public sessionService: SessionService
  ) {}

  /** The link opens the Steam offer in a new tab; the modal is done once clicked. */
  onAccept(): void {
    this.modalService.closeModals(['TradeModal']);
  }

  ngOnInit() {
    this.ngParticlesService.init(async (engine: Engine) => {
      await loadSlim(engine);
    });
  }
}
